import { observable, action } from "mobx";

import { IHRLoginOptions } from "../../app/core/lib/auth/backends/ihm";
import type { SessionBackend } from "../../app/core/lib/auth/backend";
import type { SessionState } from "../../app/core/lib/auth/backends";

export class Session<T = SessionState> {
    @observable
    currentSession: SessionBackend<T, IHRLoginOptions> | null = null;

    constructor(currentSession: SessionBackend<T, IHRLoginOptions> | null) {
        this.currentSession = currentSession;
    }

    @action
    storeSession = (session: SessionBackend<T, IHRLoginOptions>) => {
        this.currentSession = session;
    };
}
